/* --------------------------------------------------------------------------
   LUBIN V5 — la fiche produit : la galerie, le « voir plus », le compteur de
   quantité, les mouillettes dépliantes et le carrousel de suggestions.
   Tout est en délégation d'événements et sans dépendance : la page reste
   entièrement utilisable si ce fichier n'arrive jamais.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* ---- 1. LA GALERIE ----------------------------------------------------
     Une image à la fois, le chevron passe à la suivante et revient à la
     première en fin de pile. S'il n'y a qu'une vue, le chevron disparaît :
     un bouton qui ne fait rien est pire que pas de bouton. */
  function galerie(scene) {
    var vues = [].slice.call(scene.querySelectorAll('[data-lpp-vue]'));
    var bouton = scene.querySelector('[data-lpp-suivant]');
    if (!vues.length) return;

    /* La vue ouverte n'est plus forcement la premiere : sur un parfum vendu en
       plusieurs flacons, la galerie s'ouvre sur celui de la contenance
       presentee (voir la section et choisirVue plus bas). */
    var i = Math.max(0, vues.indexOf(scene.querySelector('.lpp__vue--active')));

    /* ---- le film ------------------------------------------------------
       Une vue peut porter une video. Elle arrive avec les commandes natives,
       pour rester utilisable si ce fichier n'est jamais charge ; on les retire
       ici au profit d'un bouton de lecture dessine, qui les rend au premier
       clic. Et quand on quitte la vue, le film s'arrete : un son qui continue
       derriere une photo serait inexplicable.
       13/10/2026, demande de Max : le film demarre SANS LE SON. Le visiteur le
       rallume par le haut-parleur des commandes natives, et son choix est
       garde s'il revient au film. Tant que les commandes sont affichees sur
       la vue active, la scene porte data-lpp-film-ouvert : les reperes
       s'effacent pour ne pas couvrir la barre de temps (lubin-galerie.css). */
    var film = scene.querySelector('video');
    var lire = scene.querySelector('[data-lpp-lire]');
    function majFilm() {
      var ouvert = film && film.controls && vues[i] && vues[i].contains(film);
      if (ouvert) scene.setAttribute('data-lpp-film-ouvert', '');
      else scene.removeAttribute('data-lpp-film-ouvert');
    }
    if (film) {
      film.muted = true;
      film.defaultMuted = true;
    }
    if (film && lire) {
      film.controls = false;
      lire.hidden = false;
      lire.addEventListener('click', function () {
        film.controls = true;
        lire.hidden = true;
        majFilm();
        var joue = film.play();
        if (joue && joue.catch) joue.catch(function () { film.controls = true; majFilm(); });
      });
      film.addEventListener('ended', function () { lire.hidden = false; film.controls = false; majFilm(); });
    }
    function arreteFilm() {
      if (!film) return;
      film.pause();
      if (lire && film.currentTime === 0) { lire.hidden = false; film.controls = false; }
    }

    function montre(n) {
      if (n === i) return;
      vues[i].classList.remove('lpp__vue--active');
      if (film && vues[i].contains(film)) arreteFilm();
      i = n;
      vues[i].classList.add('lpp__vue--active');
      majFilm();
    }
    scene.lubinMontre = montre;
    scene.lubinVues = vues;

    if (!bouton) return;
    if (vues.length < 2) { bouton.hidden = true; return; }
    bouton.addEventListener('click', function () { montre((i + 1) % vues.length); });
  }

  /* Amene la galerie sur la media demandee, si elle y figure. Renvoie vrai
     quand la vue a ete trouvee : sinon on laisse la galerie ou elle est. */
  function choisirVue(racine, idMedia) {
    if (!idMedia) return false;
    var scene = racine.querySelector('[data-lpp-scene]');
    if (!scene || !scene.lubinVues || !scene.lubinMontre) return false;
    for (var n = 0; n < scene.lubinVues.length; n++) {
      if (scene.lubinVues[n].dataset.lppMedia === String(idMedia)) { scene.lubinMontre(n); return true; }
    }
    return false;
  }

  /* ---- 2. LE RÉCIT : trois lignes, puis « voir plus » --------------------
     On ne replie QUE si le texte dépasse réellement : sinon le bouton
     s'afficherait au-dessus d'un paragraphe déjà entier. La mesure se refait
     au redimensionnement, parce que le nombre de lignes change avec la
     largeur. */
  function recit(bloc) {
    var texte = bloc.querySelector('[data-lpp-texte]');
    var bouton = bloc.querySelector('[data-lpp-plus]');
    if (!texte || !bouton) return;
    var ouvert = false;

    function jauge() {
      if (ouvert) return;
      bloc.setAttribute('data-replie', '');
      var deborde = texte.scrollHeight - texte.clientHeight > 2;
      bouton.hidden = !deborde;
      if (!deborde) bloc.removeAttribute('data-replie');
    }

    bouton.addEventListener('click', function () {
      ouvert = !ouvert;
      if (ouvert) {
        bloc.removeAttribute('data-replie');
        bouton.textContent = bouton.getAttribute('data-fermer');
      } else {
        bloc.setAttribute('data-replie', '');
        bouton.textContent = bouton.getAttribute('data-ouvrir');
      }
    });

    jauge();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(jauge);
    var minuteur;
    addEventListener('resize', function () { clearTimeout(minuteur); minuteur = setTimeout(jauge, 150); }, { passive: true });
  }

  /* ---- 3. LE COMPTEUR DE QUANTITÉ --------------------------------------- */
  function quantite(racine) {
    var champ = racine.querySelector('[data-lpp-qte]');
    if (!champ) return;
    var moins = racine.querySelector('[data-lpp-moins]');
    var plus = racine.querySelector('[data-lpp-plus-qte]');
    function pas(d) {
      var n = parseInt(champ.value, 10);
      if (isNaN(n)) n = 1;
      n = Math.max(1, n + d);
      champ.value = n;
      champ.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (moins) moins.addEventListener('click', function () { pas(-1); });
    if (plus) plus.addEventListener('click', function () { pas(1); });
  }

  /* ---- 3 bis. LE CHOIX DE LA CONTENANCE --------------------------------
     Dessiné sur la planche Classique : deux pastilles au-dessus du prix.
     On change la variante SANS recharger la page — le prix, le bouton et
     l'adresse suivent. L'adresse est mise à jour pour que le lien partagé
     ou le rechargement retombent sur la bonne contenance.
     ---------------------------------------------------------------------- */
  function contenances(racine) {
    var groupe = racine.querySelector('[data-lpp-contenances]');
    if (!groupe) return;
    var pastilles = [].slice.call(groupe.querySelectorAll('[data-lpp-variante]'));
    var champId = racine.querySelector('[data-lpp-id]');
    var prix = racine.querySelector('[data-lpp-prix]');
    var panier = racine.querySelector('[data-lpp-panier]');
    var dit = racine.querySelector('[data-lpp-contenance]');

    function choisir(b) {
      pastilles.forEach(function (p) {
        var actif = p === b;
        p.classList.toggle('est-choisie', actif);
        p.setAttribute('aria-pressed', actif ? 'true' : 'false');
      });
      if (champId) champId.value = b.dataset.lppVariante;
      if (prix && b.dataset.lppTarif) prix.textContent = b.dataset.lppTarif;
      /* Le bandeau du haut dit desormais la contenance qu'on vient de choisir.
         Shopify nomme ses variantes « 30 ml », la planche ecrit « 30ML » :
         on colle l'unite au chiffre pour que le bandeau garde sa graphie. */
      if (dit) dit.textContent = b.textContent.trim().replace(/(\d)\s+(ml\b)/i, '$1$2');
      /* La galerie suit le flacon choisi quand la contenance a sa propre image
         (Kigriz : 100 ml, 30 ml, recharge). Sans image, elle ne bouge pas. */
      choisirVue(racine, b.dataset.lppMedia);
      if (panier) {
        var dispo = b.dataset.lppDispo !== '0';
        panier.disabled = !dispo;
        var mot = dispo ? panier.dataset.lppMotPanier : panier.dataset.lppMotEpuise;
        if (mot) panier.textContent = mot;
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', b.dataset.lppVariante);
        window.history.replaceState({}, '', u);
      } catch (e) { /* une adresse exotique ne doit pas casser le choix */ }
    }

    pastilles.forEach(function (b) {
      b.addEventListener('click', function () { choisir(b); });
    });
  }

  /* ---- 4. LES MOUILLETTES ----------------------------------------------
     Un seul dépliant ouvert à la fois : en ouvrir un referme l'autre, comme
     demandé.

     LE TRACÉ SUIT LA HAUTEUR. Ce n'est pas un cartouche qui sort sous la
     mouillette : c'est la mouillette qui grandit et englobe le texte. Le
     chemin est donc redessiné à chaque changement de hauteur — côté gauche
     vertical, corps droit jusqu'à 802,15, biseau, pointe arrondie de 14,42
     qui garde sa taille et se recentre sur la nouvelle hauteur.

     Le viewBox suit lui aussi la hauteur, de sorte que l'échelle verticale
     reste ÉGALE à l'horizontale : sans cela, avec preserveAspectRatio="none",
     le filet et la pointe s'écraseraient à l'ouverture. */
  var LARGE = 1041.94;      /* largeur du viewBox, trace + 1 unite de filet */
  var FERMEE = 63.48;       /* la hauteur dessinee sur la maquette */

  /* On étire la SILHOUETTE DESSINÉE, on ne réinvente pas la pointe. Trois
     géométries ont été essayées côte à côte : garder la pointe à sa taille
     absolue donne une grande flèche ; garder l'angle du biseau à 6,11° donne
     un rectangle à bout mou ; étirer la silhouette garde la mouillette
     reconnaissable. C'est celle-là. */
  function tracer(mouillette, largeur, hauteur) {
    var svg = mouillette.querySelector('[data-lpp-trace]');
    if (!svg) return;
    var chemin = svg.querySelector('path');
    if (!chemin) return;
    if (largeur == null) {
      var r = mouillette.getBoundingClientRect();
      largeur = r.width; hauteur = r.height;
    }
    if (largeur < 20) return;                 /* section masquée dans l'éditeur */
    var echelle = largeur / LARGE;            /* px CSS par unité de planche */
    /* La pointe est AMORTIE : elle suit la racine du facteur, pas le facteur.
       Étirée telle quelle, elle s'aplatit en un bord droit dès que la
       mouillette grandit — son renflement reste de 8,64 alors que sa hauteur
       triple. À la hauteur fermée (f = 1) le tracé est rigoureusement celui de
       la planche. */
    var h = Math.max(16, hauteur / echelle - 2);
    var f = h / FERMEE, a = Math.sqrt(f);
    var c = h / 2, demi = 7.21 * a, ctrl = 6.29 * a;
    svg.setAttribute('viewBox', '-1 -1 ' + LARGE + ' ' + (h + 2).toFixed(2));
    chemin.setAttribute('d',
      'M 0 0 L 802.15 0 L 1031.30 ' + (c - demi).toFixed(2) +
      ' C 1039.94 ' + (c - ctrl).toFixed(2) + ' 1039.94 ' + (c + ctrl).toFixed(2) +
      ' 1031.30 ' + (c + demi).toFixed(2) +
      ' L 802.15 ' + h.toFixed(2) + ' L 0 ' + h.toFixed(2) + ' Z');
  }

  function mouillettes(bloc) {
    var tous = [].slice.call(bloc.querySelectorAll('[data-lpp-mouillette]'));
    tous.forEach(function (m) {
      var tete = m.querySelector('[data-lpp-tete]');
      if (!tete) return;

      /* Le tracé suit la hauteur à chaque image de l'animation. On lit les
         dimensions DANS l'entrée de l'observateur : appeler
         getBoundingClientRect ici forcerait un recalcul de mise en page à
         chaque frame, et déclencherait des boucles d'observation. */
      if (window.ResizeObserver) {
        new ResizeObserver(function (entrees) {
          var e = entrees[0];
          var b = e.borderBoxSize && e.borderBoxSize[0];
          if (b) tracer(m, b.inlineSize, b.blockSize);
          else tracer(m, e.contentRect.width, e.contentRect.height);
        }).observe(m);
      }
      tracer(m);

      /* Rien à faire d'autre que basculer l'attribut : le panneau est déjà
         dans la grille, la transition part donc d'un état connu. */
      tete.addEventListener('click', function () {
        var ouvert = m.hasAttribute('data-ouvert');
        tous.forEach(function (autre) {
          if (autre === m) return;
          autre.removeAttribute('data-ouvert');
          var t = autre.querySelector('[data-lpp-tete]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        m.toggleAttribute('data-ouvert', !ouvert);
        tete.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      });
    });
    /* les polices changent la hauteur du texte une fois chargées */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { tous.forEach(function (m) { tracer(m); }); });
    }
  }

  /* ---- 5. LE CARROUSEL DE SUGGESTIONS -----------------------------------
     Trois cartes visibles, on glisse d'une carte à la fois. Les flèches se
     désactivent aux extrémités plutôt que de boucler : le rang est court et
     une boucle désoriente. */
  function carrousel(racine) {
    var piste = racine.querySelector('[data-lps-piste]');
    var avant = racine.querySelector('[data-lps-avant]');
    var apres = racine.querySelector('[data-lps-apres]');
    if (!piste) return;
    var cases = piste.querySelectorAll('.lps__case');

    function pasCarte() {
      if (cases.length < 2) return piste.clientWidth;
      return cases[1].getBoundingClientRect().left - cases[0].getBoundingClientRect().left;
    }
    function maj() {
      var course = piste.scrollWidth - piste.clientWidth;
      var dort = course < 2;
      if (avant) avant.disabled = dort || piste.scrollLeft <= 1;
      if (apres) apres.disabled = dort || piste.scrollLeft >= course - 1;
      racine.toggleAttribute('data-fixe', dort);
    }
    if (avant) avant.addEventListener('click', function () { piste.scrollLeft -= pasCarte(); });
    if (apres) apres.addEventListener('click', function () { piste.scrollLeft += pasCarte(); });
    piste.addEventListener('scroll', maj, { passive: true });
    addEventListener('resize', maj, { passive: true });
    maj();
  }

  function demarre() {
    document.querySelectorAll('[data-lpp]').forEach(function (r) {
      if (r.dataset.pret) return;
      r.dataset.pret = '1';
      var scene = r.querySelector('[data-lpp-scene]');
      if (scene) galerie(scene);
      var rec = r.querySelector('[data-lpp-recit]');
      if (rec) recit(rec);
      quantite(r);
      contenances(r);
      var mou = r.querySelector('[data-lpp-mouillettes]');
      if (mou) mouillettes(mou);
    });
    document.querySelectorAll('[data-lps]').forEach(function (r) {
      if (r.dataset.pret) return;
      r.dataset.pret = '1';
      carrousel(r);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarre);
  else demarre();
  /* l'éditeur de thème recharge une section sans recharger la page */
  document.addEventListener('shopify:section:load', demarre);
})();
